module.exports = __webpack_public_path__ + "img/smallTruck-green.45b485bd.svg";